import { useQuery } from '@tanstack/react-query';
import { cutoffDatesGet } from '~/generated';
import { extractData } from '~/utils/query-utils';

export const useCutoffDates = () =>
  useQuery({
    queryFn: async () => extractData(cutoffDatesGet()),
    queryKey: ['cutOffDates'],
  });
